import React from "react";
import { Box, Chip, IconButton, Link, Tooltip, Typography } from "@mui/material";
import SchoolIcon from "@mui/icons-material/School";
import AccountBalanceRoundedIcon from "@mui/icons-material/AccountBalanceRounded";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import SettingsIcon from "@mui/icons-material/Settings";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { coresTextosGlobais, tamanhosControlesGlobais, tamanhosPaginasAdministrativas } from "../../../../estilos/global";

const texto = {
  color: coresTextosGlobais.conteudoTabela,
  fontSize: tamanhosPaginasAdministrativas.conteudoTabela,
  lineHeight: 1.45,
};
const celula = {
  px: 1.4,
  py: 0.35,
  minWidth: 0,
  display: "flex",
  alignItems: "center",
  borderRight: "1px solid var(--sear-borda, #e6eff8)",
  height: "100%",
};
const nomeStyle = {
  ...texto,
  color: "var(--sear-azul, #0767d8)",
  fontWeight: 600,
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  overflow: "hidden",
};
export default function TabelaVinculosInstitucionais({
  tipo,
  itens,
  ativo,
  onDetalhes,
  onAtos,
}) {
  const escola = tipo === "escolas";
  const grid = escola
    ? "minmax(260px, 1.4fr) minmax(145px, 0.85fr) minmax(260px, 1.3fr) minmax(180px, 0.8fr) minmax(105px, 0.45fr)"
    : "38% 24% 26% 12%";
  const titulo = escola ? "Escolas vinculadas" : "Mantenedoras vinculadas";
  const IconeNome = escola ? SchoolIcon : AccountBalanceRoundedIcon;
  const colunas = [
    [escola ? "Escola" : "Mantenedora", IconeNome],
    ["Município", LocationOnIcon],
    ...(escola ? [["Etapas/modalidades", MenuBookIcon]] : []),
    [
      escola ? "Mantenedoras" : "Escolas",
      escola ? AccountBalanceRoundedIcon : SchoolIcon,
    ],
    ["Ações", SettingsIcon],
  ];
  return (
    <Box
      data-rolagem-conteudo={ativo ? "" : undefined}
      sx={{
        mt: 1.5,
        border: "1px solid var(--sear-borda, #d7e7f7)",
        borderRadius: 2,
        bgcolor: "var(--sear-superficie, #fff)",
        overflow: "auto",
        flex: { md: "1 1 0" },
        minHeight: 0,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          px: 2,
          py: 0.75,
          bgcolor: "var(--sear-superficie-azul, #f7fbff)",
          borderBottom: "1px solid var(--sear-borda, #d7e7f7)",
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{ color: coresTextosGlobais.tituloSecao, fontWeight: 700, fontSize: tamanhosPaginasAdministrativas.tituloSecao }}
        >
          {titulo}
        </Typography>
        <Chip
          size="small"
          label={itens.length}
          sx={{
            height: "auto",
            minHeight: 21,
            bgcolor: "var(--sear-superficie-azul, #e8f4ff)",
            color: "var(--sear-azul, #0767d8)",
            fontSize: tamanhosControlesGlobais.contador,
            fontWeight: 700,
            "& .MuiChip-label": { py: 0.15, lineHeight: 1.3 },
          }}
        />
      </Box>
      <Box role="table" aria-label={titulo} sx={{ minWidth: 980 }}>
        <Box
          role="row"
          sx={{
            display: "grid",
            gridTemplateColumns: grid,
            minHeight: 34,
            alignItems: "center",
            bgcolor: "var(--sear-superficie-azul, #edf6fe)",
            borderBottom: "1px solid var(--sear-borda, #d7e7f7)",
          }}
        >
          {colunas.map(([nome, Icone]) => (
            <Box
              key={nome}
              role="columnheader"
              sx={{
                ...celula,
                py: 0.55,
                gap: 0.7,
                color: "var(--sear-azul, #2261a5)",
                justifyContent: nome === "Ações" ? "center" : "flex-start",
                "&:last-child": { borderRight: 0 },
              }}
            >
              <Icone sx={{ fontSize: 18, color: "var(--sear-azul, #087cf0)" }} />
              <Typography
                sx={{
                  fontSize: tamanhosPaginasAdministrativas.cabecalhoTabela,
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                }}
              >
                {nome}
              </Typography>
            </Box>
          ))}
        </Box>
        {itens.map((item) => {
          const modalidades = escola
            ? item.modalidades
            : item.etapasModalidades;
          const quantidade = escola
            ? item.mantenedoras.length
            : item.escolas.length;
          return (
            <Box
              key={item.id}
              role="row"
              sx={{
                display: "grid",
                gridTemplateColumns: grid,
                alignItems: "stretch",
                minHeight: 38,
                borderBottom: "1px solid var(--sear-borda, #e0ebf7)",
                "&:hover": { bgcolor: "var(--sear-superficie, #fbfdff)" },
              }}
            >
              <Box role="cell" sx={{ ...celula, gap: 1.2 }}>
                <Box sx={{ width: 30, height: 30, borderRadius: "50%", bgcolor: "var(--sear-superficie-azul, #e7f1fd)", display: "grid", placeItems: "center", flexShrink: 0 }}>
                  <IconeNome sx={{ fontSize: 19, color: "var(--sear-azul, #087cf0)" }} />
                </Box>
                <Box sx={{ minWidth: 0, flex: 1 }}>
                  
                    <Link
                      component="button"
                      type="button"
                      underline="hover"
                      onClick={() => onDetalhes(item)}
                      sx={{
                        ...nomeStyle,
                        display: "block",
                        maxWidth: "100%",
                        textAlign: "left",
                        "&:focus-visible": {
                          outline: "2px solid var(--sear-borda-forte, #087cf0)",
                          outlineOffset: 2,
                          borderRadius: 0.5,
                        },
                      }}
                    >
                      {item.nome}
                    </Link>
                  
                  {!escola && (
                    <Typography
                      sx={{
                        mt: 0,
                        lineHeight: 1.3,
                        color: "var(--sear-texto-secundario, #7b8798)",
                        fontSize: tamanhosControlesGlobais.rotulo,
                      }}
                    >
                      CNPJ: {item.cnpj ? "**.***.***/****-**" : "Não informado"}
                    </Typography>
                  )}
                </Box>
              </Box>
              <Box role="cell" sx={celula}>
                <LocationOnIcon sx={{ color: "var(--sear-azul, #087cf0)", fontSize: 16, flexShrink: 0, mr: 1 }} />
                <Typography sx={texto}>
                  {escola ? item.municipio : item.cidade}
                </Typography>
              </Box>
              {escola && <Box role="cell" sx={celula}>
                <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
                  {modalidades.map((valor) => {
                    const nome = typeof valor === "string" ? valor : valor.nome;
                    return (
                      <Chip
                        key={nome}
                        label={nome}
                        size="small"
                        sx={{
                          height: "auto",
                          minHeight: 22,
                          bgcolor: "var(--sear-superficie-azul, #eaf4ff)",
                          color: coresTextosGlobais.link,
                          fontSize: tamanhosPaginasAdministrativas.conteudoTabela,
                          borderRadius: 4,
                          "& .MuiChip-label": { px: 1, py: 0.2, lineHeight: 1.3 },
                        }}
                      />
                    );
                  })}
                </Box>
              </Box>}
              <Box role="cell" sx={celula}>
                <Typography sx={texto}>
                  {quantidade} {quantidade === 1 ? "vinculada" : "vinculadas"}
                </Typography>
              </Box>
              <Box
                role="cell"
                sx={{
                  ...celula,
                  px: 0.5,
                  justifyContent: "center",
                  gap: 0.6,
                  borderRight: 0,
                }}
              >
                <Tooltip title="Ver detalhes" arrow>
                  <IconButton
                    aria-label={`Ver detalhes de ${item.nome}`}
                    size="small"
                    onClick={() => onDetalhes(item)}
                    sx={{
                      width: 30,
                      height: 30,
                      color: "var(--sear-azul, #087cf0)",
                      bgcolor: "var(--sear-superficie-azul, #eaf4ff)",
                      border: "1px solid var(--sear-borda, #d7eaff)",
                      borderRadius: 1,
                    }}
                  >
                    <VisibilityOutlinedIcon sx={{ fontSize: 17 }} />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Ver atos" arrow>
                  <IconButton
                    aria-label={`Ver atos de ${item.nome}`}
                    size="small"
                    onClick={() => onAtos(item)}
                    sx={{
                      width: 30,
                      height: 30,
                      color: "var(--sear-azul, #009688)",
                      bgcolor: "var(--sear-sucesso-fundo, #eaf8f5)",
                      border: "1px solid var(--sear-sucesso-borda, #c3eae4)",
                      borderRadius: 1,
                    }}
                  >
                    <DescriptionOutlinedIcon sx={{ fontSize: 17 }} />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>
          );
        })}
      </Box>
      {!itens.length && (
        <Typography
          sx={{
            py: 4,
            px: 2,
            textAlign: "center",
            color: "var(--sear-texto-secundario, #7b8798)",
            fontSize: tamanhosPaginasAdministrativas.conteudoTabela,
          }}
        >
          {escola
            ? "Nenhuma escola encontrada."
            : "Nenhuma mantenedora encontrada."}
        </Typography>
      )}
    </Box>
  );
}
